import React, {PureComponent} from 'react';
import toastr from 'toastr';
import {getCurrentUserId, getJwt} from '../../../services/authService';
import http from '../../../services/httpService';
import * as userService from '../../../services/userService';
import InputNotification from '../../common/InputNotification';
import Header from '../Header';
// import ReactGA from 'react-ga';
import ReactCodeInput from 'react-verification-code-input';
import {Switch, Route} from 'react-router-dom'
import Login from "../Login";
import Dashboard from '../Dashboard'


class PhoneVerification extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            data:
                {
                    sixDigitCode: ''
                },
            spinnerActive: false,

            codeInvalid: false,
            codeValid: false,
            errors: {},
            codeResent: false,
            codeResendFailed: false,
            pinId: '',
            email: '',
            triesRemaining: 3,
            counter: 60,
            counterActive: false
        };
    }

    doSubmit = async (type = null) => {
        let pinId = this.props.location.state.pinId
        // console.log('%cpinId from location.state: ', 'color: white; background: blue; font-size: 24px', pinId)
        try {
            if (!type) {
                await this.setState({spinnerActive: true});

                const resp = await http.post('api/user/' + this.props.user.id + '/check_user_valid_phone', {
                    phone: this.props.user.phone,
                    code: this.state.data.sixDigitCode,
                    pinId: pinId ?? this.state.pinId,
                }, {headers: {authorization: getJwt()}});

                // console.log('check_user_valid_phone response: ', resp)

                let verificationStatus = await resp.data.verification_status;

                if (verificationStatus === 'approved') {
                    await this.setState({
                        spinnerActive: false,
                        codeInvalid: false,
                        codeValid: true
                    });
                    toastr.success("Phone successfully validated.");

                    const result = await http.get('api/user/' + this.props.user.id + '/teams', {headers: {authorization: getJwt()}});
                    let userTeams = await result.data.teams.data;
                    let userTeamsIn = await result.data.teams_in.data;
                    let projectsShared = await result.data.feeds_shared;
                    if (userTeams && userTeams.length) {

                        this.props.history.push('dashboard')
                        return (
                            <Switch>
                                <Route path="/dashboard" component={Dashboard}/>
                            </Switch>
                        )
                        // console.log('usao 1')
                    } else if (userTeamsIn && userTeamsIn.length) {
                        // console.log('usao 2')
                        let projectInTeam = false;
                        await userTeamsIn.map(team => team.feeds && team.feeds.length ? projectInTeam = true : '');
                        await this.props.updateUserFromServer();
                        projectInTeam ? this.props.history.push('/channels') : this.props.history.push('feed-name');
                        // } else if (projectsShared && projectsShared.length){
                        //     this.props.history.push('/channels')
                    } else {
                        // console.log('usao 3')
                        await this.props.updateUserFromServer();
                        this.props.history.push('/insert-company')
                    }
                } else {
                    await this.setState({
                        spinnerActive: false,
                        codeInvalid: true,
                        codeValid: false,
                        triesRemaining: this.state.triesRemaining - 1
                    });
                    toastr.error("Error Code #22063: Code you entered is not correct, please try again.");
                    if (this.state.triesRemaining === 0) {
                        this.startCounter()
                    }
                }
            }
        } catch (ex) {
            this.setState({spinnerActive: false});
            toastr.error("Error Code #22064: Code you entered is not correct, please try again.");
        }
    };

    startCounter = () => {
        var counter = 60;
        var interval = setInterval(() => {
            counter--;
            this.setState({counter, counterActive: true})
            if (counter === 0) {
                this.setState({triesRemaining: 3, counter: 60, counterActive: false})
                clearInterval(interval);
            }
        }, 1000);
    }

    resendConfirmationCode = async () => {
        const userId = this.props.user.id
        // console.log(userId);
        try {
            const resp = await http.post('api/user/' + userId + '/register_user_valid_phone', {
                phone: this.props.user.phone,
            }, {headers: {authorization: getJwt()}});
            // http.get('api/resend-activation/' + userId, {headers: {authorization: getJwt()}});
            console.log('%cregister_user_valid_phone response: ', 'color: white; background: green; font-size: 24px', resp)
            this.setState({codeResent: true, pinId: resp?.data?.pinId ?? resp?.data?.data?.pinId })
        } catch (ex) {
            this.setState({codeResendFailed: true})
            if (ex.response && (ex.response.status === 400 || ex.response.status === 422)) {
                const errors_obj = this.state.errors;
                let errors = {...errors_obj};
                errors = ex.response.data.errors;
                this.setState({errors});
            }
            if (ex.response && ex.response.status === 401) {
                const errors_obj = this.state.errors;
                let errors = {...errors_obj};
                errors.email = ex.response.data.message;
                this.setState({errors});
            }
        }
    }

    componentDidMount() {
        //  ReactGA.pageview(window.location.pathname + window.location.search);
        // console.log('Evo ga email iz local storage-a: ', localStorage.getItem('email'));
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'Pageview',
            pagePath: '/phone-validation',
            pageTitle: 'Phone Verification',
        });
    }

    componentDidUpdate() {
    }

    render() {

        return (
            <div className='onboarding-container'>
                <Header linkDisabled={true}/>
                <div className="onboarding-content">
                    <div className="onboarding-panel">
                        <h1 className='onboarding-title'>Check your phone!</h1>
                        <p>We’ve sent a 6-digit confirmation code to <br/>
                            <strong><span
                                style={{fontSize: 20}}>{this.props.user.phone ? this.props.user.phone : ''}.</span></strong><br/>
                            It will expire shortly, so enter it soon. <br/>
                            Made a typo? <a onClick={() => this.props.history.push('/insert-phone')}>Click here to edit
                                your phone number.</a></p>
                        <ReactCodeInput
                            // fieldHeight='80px'
                            // fieldWidth='60px'
                            disabled={this.state.counterActive}
                            onChange={async (value) => await this.setState({
                                data: {sixDigitCode: value},
                                codeInvalid: false,
                            })}
                            onComplete={async (value) => {
                                await this.setState({
                                    data: {sixDigitCode: value}
                                })
                                await this.doSubmit()
                            }}
                            autoFocus={true}
                            className={this.state.codeInvalid ? 'verification-code-invalid' : 'verification-code'}
                        />
                        {
                            this.state.spinnerActive ?
                                <InputNotification type={'loading'} text={'Validating your code...'}/> :
                                this.state.codeInvalid || this.state.counterActive ?
                                    <InputNotification type={'danger'}
                                                       text={this.state.counterActive ?
                                                           'That code wasn’t valid. Give it another try! ( 0 attempts remaining, you need to wait ' + this.state.counter + ' seconds)'
                                                           :
                                                           'That code wasn’t valid. Give it another try! (' + this.state.triesRemaining + ' attempts remaining)'}/>
                                    :
                                    this.state.codeValid ?
                                        <InputNotification type={'success'}
                                                           text={'You successfully confirmed your phone number'}/> : null
                        }
                        <div>
                            <p>Keep this window open while checking your phone.<br/><br/>
                            </p>
                            <p>Didn't receive an SMS? {
                                this.state.codeResendFailed ?
                                    <span className={'red-text'}>Confirmation code was resent</span> :
                                    this.state.codeResent ?
                                        <span className={'green-text'}>Confirmation code was resent</span> :
                                        <a onClick={() => this.resendConfirmationCode()}>Resend confirmation code</a>}
                            </p>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

export default PhoneVerification;